export default {
  GET_ITEMS(state) {
      return state.clients
  },
  GET_ITEMS_FULL_NAME(state) {
    return state.fullNameClients
  },
  COUNT_CLIENTS_HAVE_INVOICE(state) {
    return state.countClientsHaveInvoice
  },
}
